/* eslint-disable */
import { produce } from "immer";
import {
  MESSAGES_FETCH_START,
  MESSAGES_FETCH_SUCCESS,
  MESSAGES_FETCH_FAILURE,
} from "../actions/types";

const getMessages = (
  state = {
    messagesFetching: false,
    messagesData: {},
    messagesError: null,
  },
  action,
) => {
  switch (action.type) {
    case MESSAGES_FETCH_START:
      return produce(state, (draft) => {
        draft.fetching = true;
      });
    case MESSAGES_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.fetching = true;
        draft.data = action.data;
        draft.fetching = false;
      });
    case MESSAGES_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.fetching = false;
        draft.error = action.error;
      });
    default:
      return state;
  }
};

export default getMessages;
